export type CIProvider =
  | "github"
  | "gitlab"
  | "jenkins"
  | "bitbucket"
  | "circleci"
  | "azure"
  | "buildkite";

// this is more of a constant but I'm keeping it here because
// it always needs to be kept up to date with the above type
export const ALL_PROVIDERS: CIProvider[] = [
  "github",
  "gitlab",
  "jenkins",
  "bitbucket",
  "circleci",
  "buildkite",
  "azure",
];
